import { useAppQuery } from '@/hooks/useAppQuery';
import { api } from '@/lib/api-client';

import { seasonPassQueryKey } from './queryKeys';
import { type SeasonPass } from '../models/seasonPass';

export const getSeasonPass = async (id: string): Promise<SeasonPass> => {
  const response = await api.get<SeasonPass>(`/v1/season-passes/${id}`);
  return response.data;
};

/** Shared by the hook and the route loader that warms it. */
export const seasonPassQuery = (id: string) => ({
  queryKey: seasonPassQueryKey.detail(id),
  queryFn: () => getSeasonPass(id),
});

export const useSeasonPass = (id = '') => {
  return useAppQuery({ ...seasonPassQuery(id), enabled: !!id });
};
